import { Injectable } from "@angular/core";
import {
  PRIMITIVE,
  ClientMessageBrokerFactory,
  ClientMessageBroker,
  FnArg,
  UiArguments,
} from "shared/provider-webworker";

import { ReplicaLookupService } from "../../impl/ReplicaLookupService";
import { IFixingSourcePromiseLookupService } from "../IFixingSourcePromiseLookupService";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { PromiseLookupService } from "../../impl/PromiseLookupService";
import { FixingSourceLookupService } from "./FixingSourceLookupService";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class FixingSourceReplicaLookupService
  extends ReplicaLookupService<string, CubiqTS.NdfSourceImpl>
  implements IFixingSourcePromiseLookupService
{
  constructor(protected factory: ClientMessageBrokerFactory) {
    super(
      factory,
      CubiqTS.NdfSourceImpl,
      "NdfSourceImpl",
      CubiqTS.ModelUpdateImpl,
      true,
      new FixingSourceLookupService(),
    );
  }

  getFixingSource(id: string): Promise<CubiqTS.NdfSourceImpl> {
    let request = new UiArguments("getFixingSource");
    let arg1 = new FnArg(id, PRIMITIVE);
    request.args = [arg1];
    return this.broker.runOnService(request, this.VALUE);
  }

  getFixingSourcesForPair(pair: string): Promise<Array<any>> {
    let request = new UiArguments("getFixingSourcesForPair");
    let arg1 = new FnArg(pair, PRIMITIVE);
    request.args = [arg1];
    return this.broker.runOnService(request, PRIMITIVE);
  }

  getFixingSourceInPair(fixingSourceCd: string, pair: string): Promise<any> {
    let request = new UiArguments("getFixingSourceInPair");
    let arg1 = new FnArg(fixingSourceCd, PRIMITIVE);
    let arg2 = new FnArg(pair, PRIMITIVE);
    request.args = [arg1, arg2];
    return this.broker.runOnService(request, PRIMITIVE);
  }

  getAllAdaptedFixingSources(): Promise<Array<any>> {
    let request = new UiArguments("getAllAdaptedFixingSources");
    request.args = [];
    return this.broker.runOnService(request, PRIMITIVE);
  }
}
